import { pluginFactory } from '@/plugins/plugin'
import BasicHtml, { TYPE } from './BasicHtml.vue'
import services from '@/services'
import i18n from './i18n'

services.translation.init(i18n, { overwrite: false })

const BasicHtmlPlugin = pluginFactory({
  components: { BasicHtml }
})

export { BasicHtmlPlugin, BasicHtml, TYPE }
export default BasicHtml
